enum BiteLogTseCampusCardEvent {
  BalanceInquirySuccess = 1,
  BalanceInquiryError = 2,
  SaleTransaction = 3,
  SaleTransactionError = 4,
  RefundTransaction = 5,
  RefundTransactionError = 6,
  AuthorizeLimitSuccess = 7,
  AuthorizeLimitError = 8,
  RetryAttempt = 9,
  ConnectError = 10,
  ParseError = 11,
}

export { BiteLogTseCampusCardEvent };
